import { FaFacebookF, FaGooglePlusG, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { BoxSvg, CancelledSvg, CloudDrizzleingSvg, CloudDrizzleSvg1, CloudRainMoonSvg, DollerSvg, MessageSvg, NewUsersSvg, PendingSvg, ProductSvg, TruckSvg } from '../../../Data/Widgets/SvgIcons';

import Chrome from '../../../assets/images/dashboard/chrom.png';
import Firefox from '../../../assets/images/dashboard/firefox.png';
import Safari from '../../../assets/images/dashboard/safari.png';
import Opera from '../../../assets/images/dashboard/opera.png';
import Fb from '../../../assets/images/general-widget/svg-icon/2.svg';
import Tw from '../../../assets/images/general-widget/svg-icon/3.svg';
import Lin from '../../../assets/images/general-widget/svg-icon/6.svg';
import Insta from '../../../assets/images/general-widget/svg-icon/4.svg';

import Avatar1 from '../../../assets/images/user/4.jpg';
import Avatar2 from '../../../assets/images/user/1.jpg';
import Avatar3 from '../../../assets/images/user/5.jpg';
import Avatar4 from '../../../assets/images/user/6.jpg';
import Avatar5 from '../../../assets/images/user/7.jpg';
export const EarningsData = [
  {
    id: 1,
    product: 'Earnings',
    count: 6659,
    icon: <DollerSvg />,
    class: 'progress-gradient-secondary',
  },
  {
    id: 2,
    product: 'Products',
    count: 9856,
    icon: <ProductSvg />,
    class: 'progress-gradient-success',
  },
  {
    id: 3,
    product: 'Messages',
    count: 893,
    icon: <MessageSvg />,
    class: 'progress-gradient-primary',
  },
  {
    id: 4,
    product: 'New User',
    count: 45631,
    icon: <NewUsersSvg />,
    class: 'progress-gradient-danger',
  },
];

export const SalesData = [
  {
    id: 1,
    class1: 'widget-icon bg-light-primary',
    class2: 'font-primary',
    week: 'Today',
    gros: 36,
    profit: 258,
    total: 2569,
  },
  {
    id: 2,
    class1: 'widget-icon bg-light-secondary',
    class2: 'font-secondary',
    week: 'Month',

    gros: 15,
    profit: 369,
    total: 1689,
  },
  {
    id: 3,
    class1: 'widget-icon bg-light-success',
    class2: 'font-success',
    week: 'Week',
    gros: 65,
    profit: 69,
    total: 2546,
  },
  {
    id: 4,
    class1: 'widget-icon bg-light-danger',
    class2: 'font-danger',
    week: 'Week',
    gros: 65,
    profit: 69,
    total: 3562,
  },
];

export const Sales2Data = [
  {
    id: 1,
    title: 'New Order',
    color: 'primary',
    icon1: <BoxSvg />,
    order: 6981,
    gros: 68,
  },
  {
    id: 2,
    title: 'Pending Order',
    color: 'warning',
    icon1: <PendingSvg />,
    order: 783,
    gros: 12,
  },
  {
    id: 3,
    title: 'Delivered Order',
    color: 'success',
    icon1: <TruckSvg />,
    order: 647,
    gros: 50,
  },
  {
    id: 4,
    title: 'Cancelled Order',
    color: 'danger',
    icon1: <CancelledSvg />,
    order: 69,
    gros: 20,
  },
];

export const WeatherDataOb = [
  {
    title: 'Peris',
    temp: 25,
    icon: <CloudDrizzleSvg1 />,
  },
  {
    title: 'New York',
    temp: 95,
    icon: <CloudRainMoonSvg />,
  },
  {
    title: 'India',
    temp: 50,
    icon: <CloudDrizzleingSvg />,
  },
];

export const SocialList = [
  {
    icon: <FaFacebookF />,
    url: 'https://www.google.com/',
    color: 'bg-fb',
  },
  {
    icon: <FaGooglePlusG />,
    url: 'https://www.facebook.com/',
    color: 'bg-gplus',
  },
  {
    icon: <FaTwitter />,
    url: 'https://twitter.com/',
    color: 'bg-twitter',
  },
  {
    icon: <FaInstagram />,
    url: 'https://www.instagram.com/',
    color: 'bg-insta',
  },
  {
    icon: <FaLinkedinIn />,
    url: 'https://in.linkedin.com/',
    color: 'bg-linkedin',
  },
];

export const RecentActivityData = [
  {
    id: 1,
    title: 'Any desktop publishing pack ages editors.',
    date: '14 July 2022',
    time: 20 * 60 * 60 * 1000,
    color: 'primary',
  },
  {
    id: 2,
    title: 'Renewed account with this new premium plan.',
    date: '24 Aug 2022',
    time: 0.8 * 60 * 60 * 60 * 1000,
    color: 'secondary',
  },
  {
    id: 3,
    title: 'Micron to build largest chip factory in US history.',
    date: '25 July 2022',
    time: 20 * 60 * 1000,
    color: 'success',
  },
  {
    id: 4,
    title: 'Share A Case Study On One Of Your Customers.',
    date: '12 Sept 2022',
    time: 10 * 60 * 60 * 1000,
    color: 'info',
  },
];

export const UsageInBrowserTable = {
  head: ['Browser', 'Name', 'Daily', 'Weekly', 'Monthly'],
  body: [
    {
      browser: Chrome,
      name: 'Google Chrome',
      daily: 28,
      weekly: 76,
      monthly: 36,
      id: 'b-1',
    },
    {
      browser: Firefox,
      name: 'Mozilla Firefox',
      daily: 25,
      weekly: 68,
      monthly: 32,
      id: 'b-2',
    },
    {
      browser: Safari,
      name: 'Safari (web browser)',
      daily: 23,
      weekly: 65,
      monthly: 28,
      id: 'b-3',
    },
    {
      browser: Opera,
      name: 'Opera (web browser)',
      daily: 26,
      weekly: 67,
      monthly: 34,
      id: 'b-4',
    },
  ],
};

export const SocialCard = [
  {
    title: 'Facebook',
    image: Fb,
    post: 6589,
    like: 6589,
  },
  {
    title: 'Twitter',
    image: Tw,
    post: 920,
    like: 4000,
  },
  {
    title: 'Linkedin',
    image: Lin,
    post: 1234,
    like: 4369,
  },
  {
    title: 'Instagram',
    image: Insta,
    post: 369,
    like: 3458,
  },
];

export const CartProducts = {
  head: ['Details', '	Qty.', 'Price', 'Status'],
  body: [
    {
      id: 1,
      details: 'Men Casual Shirt.	',
      qty: '10',
      status: 'Done',
      statusColor: 'primary',
      price: '$6523',
      className: 'badge-light-success',
    },
    {
      id: 2,
      details: 'Rayon Women Regular Top',
      qty: '20',
      status: 'Pending',
      statusColor: 'primary',
      price: '$6565',
      className: 'badge-light-warning',
    },
    {
      id: 3,
      details: 'Flower Printed Dress',
      qty: '40',
      status: 'Done',
      statusColor: 'primary',
      price: '$9361',
      className: 'badge-light-success',
    },
    {
      id: 4,
      details: 'Polyester Women Dress',
      qty: '05',
      status: 'In process',
      statusColor: 'primary',
      price: '$2658',
      className: 'badge-light-info',
    },
    {
      id: 5,
      details: 'Cotton Regular T-Shirt',
      qty: '08',
      status: 'Pending',
      statusColor: 'primary',
      price: '$6328',
      className: 'badge-light-warning',
    },
    {
      id: 6,
      details: 'Printed Sleeve Dress',
      qty: '12',
      status: 'Pending',
      statusColor: 'primary',
      price: '$4852',
      className: 'badge-light-warning',
    },
  ],
};

export const EmployeeStatusTable = {
  head: ['Name', 'Designation', 'Skill Level', 'Experience'],
  body: [
    {
      id: 1,
      image: Avatar1,
      title: 'Julia Dio ',
      online: '14+ online',
      position: 'Designer',
      skill: 30,
      exp: '2 year',
      color: 'primary',
    },
    {
      id: 2,
      image: Avatar2,
      title: 'Holio Mako ',
      online: '250+ online',
      position: 'Developer',
      skill: 70,
      exp: '3 year',
      color: 'secondary',
    },
    {
      id: 3,
      image: Avatar3,
      title: 'Mohsib lara',
      online: '99+ online',
      position: 'Tester',
      skill: 60,
      exp: '5 month',
      color: 'primary',
    },
    {
      id: 4,
      image: Avatar4,
      title: 'Hileri Soli ',
      online: '150+ online',
      position: 'Designer',
      skill: 25,
      exp: '3 month',
      color: 'secondary',
    },
    {
      id: 5,
      image: Avatar5,
      title: 'Pusiz bia ',
      online: '19+ online',
      position: 'Developer',
      skill: 90,
      exp: '5 year',
      color: 'primary',
    },
  ],
};
